<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>查排名</el-breadcrumb-item>
        <el-breadcrumb-item>门类详情</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">门类详情</h2>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="门类名称"
                      prop="name">
          <el-input v-model="query.major_one_keyword"
                    placeholder="输入门类名称"
                    @input="fetchList()"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="年份"
                      prop="year">
          <el-select v-model="adjust_year"
                     placeholder="请选择"
                     @input="fetchList(true)">
            <el-option v-for="item in filter.years"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">查找结果</h3>
        <el-form :inline="true"
                 label-width="70px"
                 size="small">
          <el-form-item>
            <el-radio-group v-model="radio1"
                            @change="radioChange">
              <el-radio-button label="college">院校</el-radio-button>
              <el-radio-button label="major">专业</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div class="values">
        <el-tabs v-model="query.type"
                 @tab-click="handleTabChange">
          <el-tab-pane label="学术型硕士"
                       name="1"></el-tab-pane>
          <el-tab-pane label="专业学位硕士"
                       name="2"></el-tab-pane>
        </el-tabs>
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column type="index"
                           width="70"
                           label="序号"
                           align="center">
          </el-table-column>
          <el-table-column prop="major_name"
                           label="门类名称"
                           align="center">
            <template slot-scope="scope">
              ({{ scope.row.code }}){{ scope.row.name }}
            </template>
          </el-table-column>
          <el-table-column prop="os"
                           label="查询人数"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.user_count }}人</span>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center">
            <template slot-scope="scope">
              <el-button type="text"
                         @click="handelGoLevelTwo(scope.row)">学科详情</el-button>
              <el-button type="text"
                         @click="handelGoUserList(scope.row)">学员列表</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { levelOnelist, adjustConfigList } from '@/api/rank'

export default {
  components: {},
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        // year: 2024,
        type: '1',
      },
      pageTotal: 10,
      results: [],
      radio1: 'major',
      filter: {
        years: [
          {
            label: '2027年',
            value: 2027,
          },
          {
            label: '2026年',
            value: 2026,
          },
          {
            label: '2025年',
            value: 2025,
          },
          {
            label: '2024年',
            value: 2024,
          },
          {
            label: '2023年',
            value: 2023,
          },
        ],
      },
      adjust_year: '',
    }
  },
  created() {
    this.query.college_code = this.$route.params.collegeCode
    this.getYear()
  },
  methods: {
    getYear() {
      adjustConfigList().then((res) => {
        this.adjust_year = res.adjust_year
        this.fetchList()
      })
    },
    // 客户端列表请求
    fetchList() {
      this.query.year = this.adjust_year
      levelOnelist(this.query).then((res) => {
        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      this.fetchList()
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
    },
    // 同步URL请求参数
    syncQuery() {
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        })
    },
    radioChange(e) {
      if (e == 'college') {
        this.$router.replace('/rank/dataquery')
      }
    },
    // tab切换
    handleTabChange(tab) {
      this.query.type = tab.name
      this.fetchList()
    },
    handelGoUserList(row) {
      this.$router.push(
        `/rank/userlist?major_one_code=${row.code}&type=${row.type}`
      )
    },
    handelGoLevelTwo(row) {
      this.$router.push(
        `/rank/category/leveltwo?major_one_code=${row.code}&type=${this.query.type}&title=${row.name}`
      )
    },
  },
}
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .table-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0;
      width: 100.5%;
    }

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
